import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
  MoreHorizontal,
  Pencil,
  Globe,
  GlobeLock,
  Twitter,
  Trash2,
} from "lucide-react";
import type { ChangelogEntryListItem } from "@/types/changelog";

export type ChangelogAction = "edit" | "publish" | "unpublish" | "tweet" | "delete";

interface ChangelogActionsProps {
  entry: ChangelogEntryListItem;
  onAction: (entry: ChangelogEntryListItem, action: ChangelogAction) => void;
}

export function ChangelogActions({
  entry,
  onAction,
}: ChangelogActionsProps) {
  const isPublished = entry.status.toLowerCase() === "published";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-8 w-8 p-0"
          aria-label="작업 메뉴 열기"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onAction(entry, "edit")}
          className="cursor-pointer"
        >
          <Pencil className="mr-1 h-4 w-4" />
          수정
        </DropdownMenuItem>
        {isPublished ? (
          <DropdownMenuItem
            onClick={() => onAction(entry, "unpublish")}
            className="cursor-pointer"
          >
            <GlobeLock className="mr-1 h-4 w-4" />
            발행 취소
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={() => onAction(entry, "publish")}
            className="cursor-pointer"
          >
            <Globe className="mr-1 h-4 w-4" />
            발행
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={() => onAction(entry, "tweet")}
          className="cursor-pointer"
        >
          <Twitter className="mr-1 h-4 w-4" />
          트윗 생성
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onAction(entry, "delete")}
          className="text-destructive focus:text-destructive cursor-pointer"
        >
          <Trash2 className="text-destructive mr-1 h-4 w-4" />
          삭제
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
